import Chip from "@mui/material/Chip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyBRL } from "../../../util/DoubleUtil";
import CantinaPageShared from "../CantinaPageShared";

// Classificação pelo nome do enum do backend. Tipos não reconhecidos ficam neutros
// e exibem o valor como vier.
const ENTRADA = ["CREDITO", "ESTORNO", "DEVOLUCAO", "REEMBOLSO"];
const SAIDA = ["COMPRA", "DEBITO", "VENDA", "PAGAMENTO"];

const direcao = (tipo = "") => {
  const t = tipo.toUpperCase();
  if (ENTRADA.some((p) => t.includes(p))) return "entrada";
  if (SAIDA.some((p) => t.includes(p))) return "saida";
  return null;
};

const ValorExtrato = ({ tipo, valor }) => {
  const sentido = direcao(tipo);
  if (!sentido || valor === null || valor === undefined) return currencyBRL(valor);
  const entrada = sentido === "entrada";
  return (
    <Typography component="span" variant="body2" fontWeight={500} color={entrada ? "success.main" : "error.main"}>
      {entrada ? "+ " : "− "}
      {currencyBRL(Math.abs(Number(valor)))}
    </Typography>
  );
};

// O tipo vem como enum do backend (ex.: "CREDITO_PIX"); exibe em texto legível.
const tipoTexto = (tipo) =>
  tipo
    ? tipo
        .toLowerCase()
        .split("_")
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
        .join(" ")
    : "--";

const CantinaExtratoPageView = ({ pageCantinaExtrato, handleChangePage, isLoading }) => (
  <CantinaPageShared
    page={pageCantinaExtrato}
    isLoading={isLoading}
    loadingText="Carregando extrato..."
    emptyText="Nenhuma movimentação no extrato."
    handleChangePage={handleChangePage}
  >
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" sx={{ minWidth: 520 }} aria-label="Extrato da cantina">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Data e hora</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell align="right">Valor</TableCell>
            <TableCell align="right">Saldo anterior</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pageCantinaExtrato.content.map((extrato) => (
            <TableRow key={extrato.codigo} hover>
              <TableCell>{dateTimeFormat(extrato.dataHoraCriacao)}</TableCell>
              <TableCell>
                <Chip
                  size="small"
                  variant="outlined"
                  color={
                    direcao(extrato.tipoExtratoCantinaEnum) === "entrada"
                      ? "success"
                      : direcao(extrato.tipoExtratoCantinaEnum) === "saida"
                        ? "error"
                        : "default"
                  }
                  label={tipoTexto(extrato.tipoExtratoCantinaEnum)}
                />
              </TableCell>
              <TableCell align="right">
                <ValorExtrato tipo={extrato.tipoExtratoCantinaEnum} valor={extrato.valorExtrato} />
              </TableCell>
              <TableCell align="right" sx={{ color: "text.secondary" }}>
                {currencyBRL(extrato.valorSaldoAnterior)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </CantinaPageShared>
);

export default CantinaExtratoPageView;
